import { OverflowList } from '@theme/critical';
import VariantPicker from '@theme/variant-picker';
import { Component } from '@theme/component';
import { debounce, isDesktopBreakpoint, mediaQueryLarge, requestYieldCallback } from '@theme/utilities';
import { ThemeEvents, VariantSelectedEvent, VariantUpdateEvent, SlideshowSelectEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays a colour option.
 *
 * @typedef {object} Refs
 * @property {HTMLAnchorElement} colourOptionLink - The colour option link element.
 * @property {import('slideshow').Slideshow} [slideshow] - The slideshow component.
 * @property {import('quick-add').QuickAddComponent} [quickAdd] - The quick add component.
 * @property {HTMLElement} [cardGallery] - The card gallery component.
 *
 * @extends {Component<Refs>}
 */
export class ColourOption extends Component {
  requiredRefs = ['colourOptionLink'];
  #parentProduct=null;
  #parentProductIsCard=false;
  #parentGallary=null;
  #isSameAsParent=false;

  get productPageUrl() {
    return this.refs.colourOptionLink.href;
  }
/**
   * Gets the parent product element
   * @returns {HTMLAnchorElement | null} The colour option link or null
   */
  getParentProduct() {
    if(this.#parentProduct===null){
      this.#parentProductIsCard=this.closest(`product-card`)?true:false;
      this.#parentProduct=this.closest(`product-card`) || this.closest(`main[data-template^="product"]`) || null;
      this.#parentGallary=this.#parentProduct.tagName.toLowerCase()==="product-card"?this.#parentProduct.refs.cardGallery:this.#parentProduct.querySelector("media-gallery slideshow-component")?this.#parentProduct.querySelector("media-gallery slideshow-component"):this.#parentProduct.querySelector("media-gallery");
      
    }
    return this.#parentProduct;
  }
  /**
   * Gets the currently selected variant ID from the colour option
   * @returns {string | null} The variant ID or null if none selected
   */
  getSelectedVariantId() {
    
    const checkedInput = /** @type {HTMLInputElement | null} */ (
      this.querySelector('input[type="radio"]:checked[data-variant-id]')
    );

    return checkedInput?.dataset.variantId || null;
  }

  /**
   * Gets the colour option link element
   * @returns {HTMLAnchorElement | null} The colour option link or null
   */
  getColourOptionLink() {
    return this.refs.colourOptionLink || null;
  }
    /**
   * Gets the colour option title element
   * @returns {HTMLAnchorElement | null} The colour option link or null
   */
  getColourOptionTitle() {
    return this.refs.colourOptionTitle || null;
  }
    /**
   * Gets the colour option PreLoad element
   * @returns {HTMLAnchorElement | null} The colour option link or null
   */
  getColourPreLoad() {
    return this.refs.colourPreLoad || null;
  }
  getCurrentImg(){
    const parentProduct=this.getParentProduct();
    if(!parentProduct) return null;
    const gallaryimg=parentProduct.tagName.toLowerCase()==="product-card"?parentProduct.refs.cardGallery.querySelector("img"):parentProduct.querySelector("media-gallery .media-gallery__wrap slideshow-component  .product-media img")?parentProduct.querySelector("media-gallery .media-gallery__wrap slideshow-component .product-media img"):parentProduct.querySelector("media-gallery .media-gallery__wrap  .product-media img");
   return gallaryimg;
  }
  getImageWidth(gallaryimg){

    if(!gallaryimg || !gallaryimg.complete || !gallaryimg.currentSrc) return null;
    const currentSrcSearchParams=new URLSearchParams(gallaryimg.currentSrc);
    return currentSrcSearchParams.get("width");
  }
  setImageWidth(imgUrl,gallaryimg){
    const width=this.getImageWidth(gallaryimg);

    if(!width) {
      console.log(null); 
      return imgUrl;
    }
    const url=new URL(imgUrl.startsWith("//")?`https:${imgUrl}`:imgUrl);
    const currenSearchParams=url.searchParams;
    currenSearchParams.set("width",width);
    
    
    return url.href;
  }
  startPreload(){
    if(this.featuredMediaUrl) return;
    const gallaryimg=this.getCurrentImg();
    if(!gallaryimg) return;
     if(!gallaryimg.complete) return gallaryimg.addEventListener(load,this.startPreload);
     const preLoad=this.getColourPreLoad();
      if(preLoad){
        const preLoadUrl=this.setImageWidth(preLoad.dataset.featuredMediaUrl,gallaryimg);
        this.featuredMediaUrl=preLoadUrl;
        const link =document.createElement("link");
        link.rel="preload";
        link.href=preLoadUrl;
        link.as="image";
        link.addEventListener("load",(e)=>{
          e.currentTarget.remove();
        })
        preLoad.appendChild(link);
      }
  }
  isBeingViewed(beingViewed,observer){
    
    if(beingViewed && document.readyState != 'loading'){ 
      observer.disconnect();
      const parentProduct=this.getParentProduct();
      if(!parentProduct) return null;
      if(parentProduct.tagName.toLowerCase()==="product-card"){
        parentProduct.addEventListener("mouseenter",(event)=>{
          this.startPreload();
        },{once:true});
      }else{
        this.startPreload();
      }
      }
    

  }

  #fetchProductPageHandler = () => {
    this.refs.quickAdd?.fetchProductPage(this.productPageUrl);
  };

  /**
   * Navigates to a URL link. Respects modifier keys for opening in new tab/window.
   * @param {Event} event - The event that triggered the navigation.
   * @param {URL} url - The URL to navigate to.
   */
  #navigateToURL = (event, url) => {
    // Check for modifier keys that should open in new tab/window (only for mouse events)
    const shouldOpenInNewTab =
      event instanceof MouseEvent && (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1);

    if (shouldOpenInNewTab) {
      event.preventDefault();
      window.open(url.href, '_blank');
      return;
    } else {
      //window.location.href = url.href;
      window.location.replace(url.href);
    }
  };

  connectedCallback() {
    super.connectedCallback();
this.#isSameAsParent=false;
    const options = {
        root: document.documentElement,
    };

    const link = this.refs.colourOptionLink;
    if (!(link instanceof HTMLAnchorElement)) throw new Error('colour option link not found');
    const parent= this.getParentProduct();
    if(this.dataset.parentProductId===this.dataset.productId){
      this.classList.add("selected");
      this.#isSameAsParent=true;
    }
    this.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    this.addEventListener(ThemeEvents.variantSelected, this.#handleVariantSelected);
    this.addEventListener(SlideshowSelectEvent.eventName, this.#handleSlideshowSelect);
    
    if(this.#parentProductIsCard===true){
      console.log("co pc");
      this.addEventListener('click', this.clickColourOptionCard);
    }else{
      this.addEventListener('click', this.navigateToProduct);
    }
    this.addEventListener('mouseover', this.hoverColourOption);
    this.addEventListener('mouseout', this.mouseoutColourOption);

    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
         this.isBeingViewed(entry.intersectionRatio > 0.2,observer);
        }
      }); 
    }, options);

    observer.observe(this);
    // Preload the next image on the slideshow to avoid white flashes on previewImage
    setTimeout(() => {
      if (this.refs.slideshow?.isNested) {
        this.#preloadNextPreviewImage();
      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.navigateToProduct);
  }

  #preloadNextPreviewImage() {
    const currentSlide = this.refs.slideshow?.slides?.[this.refs.slideshow?.current];
    currentSlide?.nextElementSibling?.querySelector('img[loading="lazy"]')?.removeAttribute('loading');
  }



  /**
   * Handles the variant selected event.
   * @param {VariantSelectedEvent} event - The variant selected event.
   */
  #handleVariantSelected = (event) => {
    if (event.target !== this.variantPicker) {
      this.variantPicker?.updateSelectedOption(event.detail.resource.id);
    }
  };

  /**
   * Handles the variant update event.
   * Updates price, checks for unavailable variants, and updates product URL.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #handleVariantUpdate = (event) => {
    // Stop the event from bubbling up to the section, variant updates triggered from colour options are fully handled
    // by this component and should not affect anything outside the card.
    event.stopPropagation();

    this.updatePrice(event);
    this.#isUnavailableVariantSelected(event);
    this.#updateProductUrl(event);
    this.refs.quickAdd?.fetchProductPage(this.productPageUrl);

    if (event.target !== this.variantPicker) {
      this.variantPicker?.updateVariantPicker(event.detail.data.html);
    }

    this.#updateVariantImages();
    this.#previousSlideIndex = null;

    // Remove attribute after re-rendering since a variant selection has been made
    this.removeAttribute('data-no-swatch-selected');

    // Force overflow list to reflow after variant update
    // This fixes an issue where the overflow counter doesn't update properly in some browsers
    this.#updateOverflowList();
  };

  /**
   * Forces the overflow list to recalculate by dispatching a reflow event.
   * This ensures the overflow counter displays correctly after variant updates.
   */
  #updateOverflowList() {
    // Find the overflow list in the variant picker
    const overflowList = this.querySelector('swatches-variant-picker-component overflow-list');
    const isActiveOverflowList = overflowList?.querySelector('[slot="overflow"]') ? true : false;
    if (!overflowList || !isActiveOverflowList) return;

    // Use requestAnimationFrame to ensure DOM has been updated
    requestAnimationFrame(() => {
      // Dispatch a reflow event to trigger recalculation
      overflowList.dispatchEvent(
        new CustomEvent('reflow', {
          bubbles: true,
          detail: {},
        })
      );
    });
  }

  /**
   * Updates the DOM with a new price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice(event) {
    const priceContainer = this.querySelectorAll(`product-price [ref='priceContainer']`)[1];
    const newPriceElement = event.detail.data.html.querySelector(`product-price [ref='priceContainer']`);

    if (newPriceElement && priceContainer) {
      morph(priceContainer, newPriceElement);
    }
  }

  /**
   * Updates the product URL based on the variant update event.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #updateProductUrl(event) {
    const anchorElement = event.detail.data.html?.querySelector('colour-option a');
    const featuredMediaUrl = event.detail.data.html
      ?.querySelector('product-card-link')
      ?.getAttribute('data-featured-media-url');

    // If the colour option is inside a product link, update the product link's featured media URL
    if (featuredMediaUrl && this.closest('product-card-link'))
      this.closest('product-card-link')?.setAttribute('data-featured-media-url', featuredMediaUrl);

    if (anchorElement instanceof HTMLAnchorElement) {
      // If the href is empty, don't update the product URL eg: unavailable variant
      if (anchorElement.getAttribute('href')?.trim() === '') return;

      const productUrl = anchorElement.href;
      const { colourOptionLink, productTitleLink, cardGalleryLink } = this.refs;

      colourOptionLink.href = productUrl;
      if (cardGalleryLink instanceof HTMLAnchorElement) {
        cardGalleryLink.href = productUrl;
      }
      if (productTitleLink instanceof HTMLAnchorElement) {
        productTitleLink.href = productUrl;
      }
    }
  }

  /**
   * Checks if an unavailable variant is selected.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #isUnavailableVariantSelected(event) {
    const allVariants = /** @type {NodeListOf<HTMLInputElement>} */ (
      event.detail.data.html.querySelectorAll('input:checked')
    );

    for (const variant of allVariants) {
      this.#toggleAddToCartButton(variant.dataset.optionAvailable === 'true');
    }
  }

  /**
   * Toggles the add to cart button state.
   * @param {boolean} enable - Whether to enable or disable the button.
   */
  #toggleAddToCartButton(enable) {
    const addToCartButton = this.querySelector('.add-to-cart__button button');

    if (addToCartButton instanceof HTMLButtonElement) {
      addToCartButton.disabled = !enable;
    }
  }

  /**
   * Hide the variant images that are not for the selected variant.
   */
  #updateVariantImages() {
    const { slideshow } = this.refs;
    if (!this.variantPicker?.selectedOption) {
      return;
    }

    const selectedImageId = this.variantPicker?.selectedOption.dataset.optionMediaId;

    if (slideshow && selectedImageId) {
      const { slides = [] } = slideshow.refs;

      for (const slide of slides) {
        if (slide.getAttribute('variant-image') == null) continue;

        slide.hidden = slide.getAttribute('slide-id') !== selectedImageId;
      }

      slideshow.select({ id: selectedImageId }, undefined, { animate: false });
    }
  }

  /**
   * Gets all variant inputs.
   * @returns {NodeListOf<HTMLInputElement>} All variant input elements.
   */
  get allVariants() {
    return this.querySelectorAll('input[data-variant-id]');
  }

  /**
   * Gets the variant picker component.
   * @returns {VariantPicker | null} The variant picker component.
   */
  get variantPicker() {
    return this.querySelector('swatches-variant-picker-component');
  }
  /** @type {number | null} */
  #previousSlideIndex = null;

  /**
   * Handles the slideshow select event.
   * @param {SlideshowSelectEvent} event - The slideshow select event.
   */
  #handleSlideshowSelect = (event) => {
    if (event.detail.userInitiated) {
      this.#previousSlideIndex = event.detail.index;
    }
  };

  /**
   * Previews a variant.
   * @param {string} id - The id of the variant to preview.
   */
  previewVariant(id) {
    const { slideshow } = this.refs;

    if (!slideshow) return;

    this.resetVariant.cancel();
    slideshow.select({ id }, undefined, { animate: false });
  }

  /**
   * Previews the next image.
   * @param {PointerEvent} event - The pointer event.
   */
  previewImage(event) {
    if (event.pointerType !== 'mouse') return;

    const { slideshow } = this.refs;

    if (!slideshow) return;

    this.resetVariant.cancel();

    if (this.#previousSlideIndex != null && this.#previousSlideIndex > 0) {
      slideshow.select(this.#previousSlideIndex, undefined, { animate: false });
    } else {
      slideshow.next(undefined, { animate: false });
      setTimeout(() => this.#preloadNextPreviewImage());
    }
  }

  /**
   * Resets the image to the variant image.
   * @param {PointerEvent} event - The pointer event.
   */
  resetImage(event) {
    if (event.pointerType !== 'mouse') return;

    const { slideshow } = this.refs;

    if (!this.variantPicker) {
      if (!slideshow) return;
      slideshow.previous(undefined, { animate: false });
    } else {
      this.#resetVariant();
    }
  }

  /**
   * Resets the image to the variant image.
   */
  #resetVariant = () => {
    const { slideshow } = this.refs;

    if (!slideshow) return;

    // If we have a selected variant, always use its image
    if (this.variantPicker?.selectedOption) {
      const id = this.variantPicker.selectedOption.dataset.optionMediaId;
      if (id) {
        slideshow.select({ id }, undefined, { animate: false });
        return;
      }
    }

    // No variant selected - use initial slide if it's valid
    const initialSlide = slideshow.initialSlide;
    const slideId = initialSlide?.getAttribute('slide-id');
    if (initialSlide && slideshow.slides?.includes(initialSlide) && slideId) {
      slideshow.select({ id: slideId }, undefined, { animate: false });
      return;
    }

    // No valid initial slide or selected variant - go to previous
    slideshow.previous(undefined, { animate: false });
  };

  /**
   * Intercepts the click event on the colour option anchor, we want
   * to use this to add an intermediate state to the history.
   * This intermediate state captures the page we were on so that we
   * navigate back to the same page when the user navigates back.
   * In addition to that, it captures the colour option anchor so that we
   * have the specific colour option in view.
   *
   * A colour option can have other interactive elements like variant picker,
   * so we do not navigate if the click was on one of those elements.
   *
   * @param {Event} event
   */
  navigateToProduct = (event) => {
    console.log("click product");
    if (!(event.target instanceof Element)) return;
    // Don't navigate if this colour option is marked as no-navigation (e.g., in theme editor)
    if (this.hasAttribute('data-no-navigation')) return;
    event.stopPropagation();
    const interactiveElement = event.target.closest('button, input, label, select, [tabindex="1"]');

    // If the click was on an interactive element, do nothing.
    if (interactiveElement) {
      return;
    }

    const link = this.refs.colourOptionLink;
    if (!link.href) return;
    const linkURL = new URL(link.href);

    const productCardAnchor = link.getAttribute('id');
    if (!productCardAnchor) return;

    const url = new URL(window.location.href);
    const parent = this.closest('li');
    url.hash = productCardAnchor;
    if (parent && parent.dataset.page) {
      url.searchParams.set('page', parent.dataset.page);
    }

    if (!window.Shopify.designMode) {
      requestYieldCallback(() => {
        history.replaceState({}, '', url.toString());
      });
    }

    const targetLink = event.target.closest('a');
    // Let the native navigation handle the click if it was on a link.
    if (!targetLink) {
      this.#navigateToURL(event, linkURL);
    }
  };
  
  
   /**
   * Intercepts the hover event on the colour option anchor, we want
   * to use this to add an intermediate state to the history.
   * This intermediate state captures the page we were on so that we
   * navigate back to the same page when the user navigates back.
   * In addition to that, it captures the colour option anchor so that we
   * have the specific colour option in view.
   *
   * A colour option can have other interactive elements like variant picker,
   * so we do not navigate if the click was on one of those elements.
   *
   * @param {Event} event
   */
  clickColourOptionCard=(event)=>{
    console.log("click Card");
    if (!(event.target instanceof Element)) return;
    event.stopPropagation();
    event.preventDefault();
     const parentProduct=this.getParentProduct();
    if(!parentProduct) return;
   //console.log(parentProduct.refs);
    const productTitleLink=parentProduct.refs.productTitleLink;
    const productCardLink=parentProduct.refs.productCardLink;
    const productPriceContainer=parentProduct.refs.priceContainer;
    const quickAdd=parentProduct.refs.quickAdd;
    const myLink=this.refs.colourOptionLink;
    if(productTitleLink) productTitleLink.querySelector("p").textContent=this.dataset.title;
    if(productCardLink) productCardLink.href=myLink.href;
    if(productTitleLink) productTitleLink.href=myLink.href;
    parentProduct.querySelector("colour-option.selected").classList.remove("selected");
    this.classList.add("selected");
    this.setOptionOnHover(this);
    if(quickAdd) this.setQuickAdd(this,quickAdd)
  }
  setQuickAdd(colourOption,quickAdd){
    if(!quickAdd) return
    const productFormComponent=quickAdd.querySelector("product-form-component");
    const inputVarId=productFormComponent.refs.variantId;

  }
  setOptionOnHover=(colourOption)=>{
    const gallary=colourOption.#parentGallary;
    if(!gallary) return console.log("no gallary to set image");
    if(!gallary.querySelector("option-on-hover")) gallary.appendChild(document.createElement("option-on-hover"))
    const gallaryOption=gallary.querySelector("option-on-hover"); 
    if(gallaryOption.type!="gallary") gallaryOption.type="gallary";
    if(gallaryOption.ownerid!=colourOption.dataset.productId){
      const preLoad=colourOption.getColourPreLoad();
      const imgUrl=colourOption.featuredMediaUrl?colourOption.featuredMediaUrl:preLoad.dataset.featuredMediaUrl;
      gallaryOption.setAttribute("ownerid",colourOption.dataset.productId);
      gallaryOption.style.backgroundImage=preLoad?`url(${imgUrl})`:"";
    }
    gallaryOption.setAttribute("isvisible",true);
  }
   /**
   * Intercepts the hover event on the colour option anchor, we want
   * to use this to add an intermediate state to the history.
   * This intermediate state captures the page we were on so that we
   * navigate back to the same page when the user navigates back.
   * In addition to that, it captures the colour option anchor so that we
   * have the specific colour option in view.
   *
   * A colour option can have other interactive elements like variant picker,
   * so we do not navigate if the click was on one of those elements.
   *
   * @param {Event} event
   */
  hoverColourOption=(event)=>{
    console.log("hover");
    if (!(event.target instanceof Element)) return;
     const parentProduct=this.getParentProduct();
    if(!parentProduct) return;
    this.setOptionOnHover(this);
  }
  /**
   * Intercepts the mouse out event on the colour option anchor, we want
   * to use this to add an intermediate state to the history.
   * This intermediate state captures the page we were on so that we
   * navigate back to the same page when the user navigates back.
   * In addition to that, it captures the colour option anchor so that we
   * have the specific colour option in view.
   *
   * A colour option can have other interactive elements like variant picker,
   * so we do not navigate if the click was on one of those elements.
   *
   * @param {Event} event
   */
  mouseoutColourOption=(event)=>{
    if (!(event.target instanceof Element)) return;
     const parentProduct=this.getParentProduct();
    if(!parentProduct) return;
    if(this.classList.contains("selected")) return;
    const selected=parentProduct.querySelector("colour-option.selected");
    if(selected.#isSameAsParent){
      parentProduct.querySelectorAll('option-on-hover[isvisible="true"]').forEach((item)=>{
        item.setAttribute("isvisible",false);
      })
    }else{
      this.setOptionOnHover(selected);
    }
  }
  /**
   * Resets the variant.
   */
  resetVariant = debounce(this.#resetVariant, 100);
}

if (!customElements.get('colour-option')) {
  customElements.define('colour-option', ColourOption);
}

class OptionOnHover extends HTMLElement {
  static observedAttributes = ["isvisible","connectedId","type","ownerid"];
  constructor() {
    super();
    
  } 
  connectedCallback() {
    
    if(!this.hasAttribute("isvisible")) this.setAttribute("isvisible","false");
    if(!this.hasAttribute("connectedId")) this.setAttribute("connectedId","");
    if(!this.hasAttribute("type")) this.setAttribute("type","");
    if(!this.hasAttribute("ownerid")) this.setAttribute("ownerid","");

    
  }
  attributeChangedCallback(name, oldValue, newValue) {
    
  }
}

if (!customElements.get('option-on-hover')) {
  customElements.define('option-on-hover', OptionOnHover);
}
